import React, {CSSProperties, forwardRef, memo, useEffect, useRef, useState} from "react";
import './GroupItem.css'
import {
    batchUpdateTags,
    getAllCardList,
    getNoteList,
    statBoardCountByTags,
    statusCardListByTagsName, statusProjectTagCountByTagName,
    tagsByGroupId
} from "../../../model";
import {
    arrayMove,
    verticalListSortingStrategy,
    horizontalListSortingStrategy,
    SortableContext,
    useSortable,
    rectSortingStrategy,
} from '@dnd-kit/sortable';
import {DndContext, DragEndEvent} from "@dnd-kit/core";
import {Dropdown, Flex, Popover, Tag} from "antd";
import {getImagePath, getImagePathSvg, getImagePathWithTheme, getItem, isDarkMode} from "@/utils";
import {
    IconAddToFavor,
    IconAddToFavorWithTheme,
    IconDelete,
    IconDeleteRed, IconDeleteWhite,
    IconEdit,
    IconMenuExportPcanvas,
    IconRemoveFavor
} from "@/Icon";
import {t} from "i18next";
import {
    DEFAULT_DARK_TAG_BACKGROUND_COLOR,
    DEFAULT_TAG_BACKGROUND_COLOR,
    MAP_GROUP_BACKGROUND_COLOR,
    MAP_GROUP_BACKGROUND_ICON,
    MAX_Z_INDEX
} from "@/Const";
import {getFavorChildrenMenu} from "@/Utility";
import global from "@/global";
import {atomIsTagSelectMode} from "@/views/Tags/PageTags";
import {useAtom} from "jotai";

let mIsDragged = false;
let isOpenContextMenu = false;
const GroupItem = forwardRef((props:{group:any,arrayAllTags?:any,searchKey?:any,onEditGroup:any,onAddTag:any,onDeleteGroup:any,onTagAction:any,arrayLibrarys:any,arrayProjects:any,arrayBoards:any,onRefreshTag:any}, ref) => {
    const [items,setItems] = useState([]);
    const mArrayLibrarys = useRef(null);
    const mArrayProjects = useRef(null);
    const mArrayBoards = useRef(null);

    const { listeners, transform, transition, isDragging, setNodeRef } = useSortable({ id: props.group.id });
    const groupCommonStyle: React.CSSProperties = {
        cursor: 'pointer',
        transition: 'unset', // Prevent element from shaking after drag
    };
    const styleGroupItem = transform
        ? {
            ...groupCommonStyle,
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
        }
        : groupCommonStyle;

    useEffect(()=>{
        if (props.group){
            searchTags();
        }
    },[props.group,props.searchKey,props.arrayProjects]);

    useEffect(()=>{
        // mArrayProjects.current = props.arrayProjects;
        // mArrayLibrarys.current = props.arrayLibrarys;
        // mArrayBoards.current = props.arrayBoards;
        if (props.group.items){
            setItems(props.group.items);
            staticTagCount(props.group.items);
        }
    },[])

    useEffect(() => {
        if (items.length > 0){
            staticTagCount(props.group.items);
        }
    }, [props.arrayProjects]);

    const staticTagCount = async (items)=>{
        const arrayTags:any = [...items];
        for (let i=0;i<arrayTags.length;i++){
            const item = arrayTags[i];
            item.count = 0;
            // item.count += props.arrayLibrarys.filter(p=>p.tags?.includes(item.name)).length;
            // item.count += props.arrayProjects.filter(p=>p.tags?.includes(item.name)).length;
            // item.count += props.arrayBoards.filter(p=>p.tags?.includes(item.name)).length;

            item.count += await statusCardListByTagsName(item.name);
            item.count += await statBoardCountByTags(item.name);
            item.count += await statusProjectTagCountByTagName(item.name);

            //把原始的集合数量也补充上，给删除空白tag使用...
            const originItem = items[i];
            originItem.count = item.count;
        }
        setItems(arrayTags);
    }

    //组的操作菜单......
    const getArrayGroupMore:any = (tag:any)=>{
        return [
            getItem(t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
                props.onEditGroup(props.group);
            }),
            // getItem(tag?.isFavirated == 1?t('Cancel favor'):t("Add to Favorites"), 'favor', tag?.isFavirated == 1?<IconRemoveFavor/>:<IconAddToFavor/>, undefined, undefined, () => {
            //     props.onTagAction('favor',tag);
            // }),
            getItem(<span className={isDarkMode()?'':'delete-color'}>{t("Delete")}</span>, 'delete',
                <IconDeleteRed/>, undefined, undefined, () => {
                    props.onDeleteGroup(props.group);
                }),
        ]
    }

    const tagsByGroupIddddddd = (nGroupId:any)=>{
        if (nGroupId == -1){
            return props.arrayAllTags.filter(p=>!p.groupId || p.groupId == -1);
        }
        return props.arrayAllTags.filter(p=>p.groupId == nGroupId);
    }

    /**
     * 搜索标签....
     */
    const searchTags = async ()=>{
        let szSearchKey = '';
        if (props.searchKey){
            szSearchKey = props.searchKey?.toLowerCase();
        }
        let arrayTags = await tagsByGroupId(props.group.id);
        if (szSearchKey){
            if (props.group.name.toLowerCase().includes(szSearchKey)){

            }else{
                arrayTags = arrayTags.filter(p=>p.name.toLowerCase().includes(szSearchKey));
            }
        }
        arrayTags.sort((a,b)=>{
            if (a.createTime && b.createTime){
                return a.createTime - b.createTime;
            }
            return 0;
        })
        arrayTags.sort((a,b)=>{
            if (a.tagSort != undefined && b.tagSort != undefined){
                return a.tagSort - b.tagSort;
            }
            return 0;
        })

        // const arrayLibrarys:any = props.arrayLibrarys;//await getAllCardList();
        // const arrayProjects:any = props.arrayProjects;//await getNoteList();
        //
        // for (let i=0;i<arrayTags.length;i++){
        //     const item = arrayTags[i];
        //     item.count = 0;
        //     item.count += arrayLibrarys.filter(p=>p.tags?.includes(item.name)).length;
        //     item.count += arrayProjects.filter(p=>p.tags?.includes(item.name)).length;
        //     item.count += props.arrayBoards.filter(p=>p.tags?.includes(item.name)).length;
        // }
        setItems(arrayTags);

        staticTagCount(arrayTags);

        if (props.onRefreshTag){
            props.onRefreshTag(arrayTags);
        }
    }

    const handleDragEnd = (event: DragEndEvent) => {
        isOpenContextMenu = false;
        const { active, over } = event;
        if (!over) {
            return;
        }
        if (active.id !== over.id) {
            let arrayNew = [...items];

            const oldIndex = arrayNew.findIndex((item) => item.id === active.id);
            const newIndex = arrayNew.findIndex((item) => item.id === over.id);
            arrayNew = arrayMove(arrayNew, oldIndex, newIndex);
            setItems(arrayNew);

            for (let i=0;i<arrayNew.length;i++){
                arrayNew[i].tagSort = i;
            }
            batchUpdateTags(arrayNew);

            // setItems((data) => {
            //     const oldIndex = data.findIndex((item) => item.id === active.id);
            //     const newIndex = data.findIndex((item) => item.id === over.id);
            //     return arrayMove(data, oldIndex, newIndex);
            // });
        }
    };

    const handleDragMove = (event)=>{
        mIsDragged = true;
    }

    const getStyle = ()=>{
        const customStyle:CSSProperties = {...styleGroupItem};
        if (props.searchKey){
            if (items.length > 0){
                customStyle.display = 'flex';
            }else{
                customStyle.display = 'none';
            }
        }else{
            customStyle.display = 'flex';
        }
        customStyle.cursor = 'pointer';
        return customStyle;
    }

    return(
        <div className={'groupitem flex-col'} style={getStyle()} ref={setNodeRef} onPointerDown={(e)=>{
            // console.log(e);
            if (isOpenContextMenu || e.target?.className?.includes('ant-dropdown')) {
            }else {
                // 必须调用 listeners.onPointerDown，否则拖拽失效
                listeners.onPointerDown?.(e);
            }
        }} {...(props.group.dragDisabled ? {} : {  })}>
            <div className={'flex-row-vertical-center'}>
                <div className={'flex-row-vertical-center'} style={{marginLeft:'-20px'}}>
                    <img className={'img-16 img-sort'} style={{marginTop:'-1px',visibility:props.group.dragDisabled?'hidden':'visible'}} src={getImagePathSvg('frame_sort')}/>
                    <span className={'groupitem-title ml-4'}>{props.group?.name}</span>
                </div>

                <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                    <img className={'img-14 cursor-pointer'} src={getImagePathWithTheme('tag_group_add.svg')} onMouseDown={()=>{
                        props.onAddTag(props.group);
                    }}/>
                    {
                        props.group.id != -1 &&
                        <Dropdown menu={{items:getArrayGroupMore()}} overlayStyle={{minWidth:'200px'}} onOpenChange={(e)=>{
                            isOpenContextMenu = e;
                        }}>
                            <img className={'img-14 ml-12 cursor-pointer'} src={getImagePathWithTheme('tag_h_more.svg')}/>
                        </Dropdown>
                    }
                </div>
            </div>

            <div className={'mt-16'}>
                <DndContext onDragStart={(e)=>{
                    isOpenContextMenu = true;
                }} onDragEnd={handleDragEnd} onDragMove={handleDragMove}>
                    <SortableContext items={items} strategy={rectSortingStrategy}>
                        <Flex gap="16px 6px" wrap={"wrap"}>
                            {
                                items.map(p=>{
                                    return(
                                        <DraggableTag tag={p} key={p.id} onTagAction={props.onTagAction}/>
                                    )
                                })
                            }
                        </Flex>
                    </SortableContext>
                </DndContext>
            </div>

        </div>
    )
});


/*****************************---tag---***************************************/
const commonStyle: React.CSSProperties = {
    cursor: 'pointer',
    transition: 'unset', // Prevent element from shaking after drag
};
const DraggableTag: React.FC<any> = memo((props) => {
    const {onTagAction} = props;
    const { listeners, transform, transition, isDragging, setNodeRef } = useSortable({ id: props.tag.id });
    const [isHover,setIsHover] = useState(false);
    const [isMoreMenuOpened,setIsMoreMenuOpened] = useState(false);
    const [isShowContextMenu,setIsShowContextMenu] = useState(false);
    const [tag,setTag] = useState(props.tag);

    const [isTagSelectMode,setIsTagSelectMode] = useAtom(atomIsTagSelectMode);

    useEffect(() => {
        setTag(props.tag);
    }, [props.tag]);

    const arrayGroupMore = ()=>{
        return [
            getItem(t("Edit"), 'edit', <IconEdit/>, undefined, undefined, () => {
                onTagAction('edit',tag);
            }),
            getItem(tag?.isFavirated == 1?t('Cancel favor'):t("Add to Favorites"), 'favor', tag?.isFavirated == 1?<IconAddToFavorWithTheme/>:<IconAddToFavorWithTheme/>, getFavorChildrenMenu(tag?.isFavirated,(key)=>{
                onTagAction('favor', {...tag,key:key});
            }), undefined, (info:any) => {
                if (global.g_arrayFavorFolders.some(p=>p.id == info.key))return;
                onTagAction('favor',tag);
            }),
            getItem(<span className={isDarkMode()?'':'delete-color'}>{t("Delete")}</span>, 'delete', isDarkMode()?<IconDeleteWhite/>:<IconDeleteRed/>, undefined, undefined, () => {
                onTagAction('delete',tag);
            }),
        ]
    }

    const style = transform
        ? {
            ...commonStyle,
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
            transition: isDragging ? 'unset' : transition, // Improve performance/visual effect when dragging
        }
        : commonStyle;
    style.height = '36px';
    style.lineHeight = '36px';
    style.padding = '0 12px';
    style.borderRadius = '8px';
    style.border = 'none';
    style.background = tag.isSelected?'var(--primary-color)':(tag.backgroundColor || DEFAULT_TAG_BACKGROUND_COLOR);
    if (isDarkMode()){
        if (style.background == DEFAULT_TAG_BACKGROUND_COLOR || style.background == "#E8E9ED"){
            style.background = DEFAULT_DARK_TAG_BACKGROUND_COLOR;
        }
    }else{
        if (style.background?.toUpperCase() == "#E8E9ED"){
            style.background = DEFAULT_TAG_BACKGROUND_COLOR;
        }
    }

    /**
     * 标签文本颜色
     */
    const getTextColor = ()=>{
        let szTextColor = MAP_GROUP_BACKGROUND_COLOR[tag?.backgroundColor] || '#000000';
        if (szTextColor == '#000000' && isDarkMode()){
            szTextColor = '#FFFFFF';
        }
        if (tag.isSelected){
            szTextColor = '#FFFFFF';
        }
        return szTextColor;
    }

    const getIconName = ()=>{
        let szIconName = MAP_GROUP_BACKGROUND_ICON[tag?.backgroundColor] || 'tag_more_gray';
        if (szIconName == "tag_more_gray" && isDarkMode()){
            szIconName = "tag_more_gray_white";
        }
        return szIconName;
    }

    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = async function (event:any){
                        onTagAction('favor', {...tag,key:'favor'});
                        setIsShowContextMenu(false);
                    }
                }
            }
        },100)
    }


    return (
        <Dropdown trigger={['contextMenu']} open={isShowContextMenu} menu={{items:arrayGroupMore()}} onOpenChange={(e) => {
            setIsShowContextMenu(e);
            isOpenContextMenu = e;
            patchMenuFavor();
        }} overlayStyle={{minWidth:'200px'}}>
            <Tag style={style} ref={setNodeRef} {...listeners} onMouseUp={(event:any)=>{
                if (mIsDragged) {
                    mIsDragged = false;
                    return;
                }
                if (event.button == 0) {
                    const newTag = {...tag};
                    if (!newTag.isSelected) {
                        newTag.isSelected = true;
                    }else {
                        newTag.isSelected = false;
                    }
                    setTag(newTag);
                    onTagAction('click', newTag);
                }
            }} onMouseEnter={()=>{
                setIsHover(true);
            }} onMouseLeave={()=>{
                setIsHover(false);
                setIsMoreMenuOpened(false);
            }}>
                <div className={'flex-row-vertical-center'}>
                    <div style={{width: '8px'}}></div>
                    <span className={'font-family-medium'} style={{color: getTextColor()}}>{tag.name}</span>
                    <div className={'flex-center'} style={{width: '30px'}}>
                        {
                            (!isHover || isTagSelectMode) &&
                            <span className={'font-family-medium ml-12'} style={{color: getTextColor()+'88'}}>{tag.count}</span>
                        }
                        {
                            isHover && !isTagSelectMode &&
                            <Popover
                                trigger={['click']}
                                arrow={false}
                                placement={"bottom"}
                                open={isMoreMenuOpened}
                                onOpenChange={(e) => {
                                    setIsMoreMenuOpened(e);
                                }}
                                content={
                                    arrayGroupMore().map(p => {
                                        return (
                                            <>
                                                {
                                                    p.children?.length > 0 ?
                                                        //二级
                                                        <Popover zIndex={MAX_Z_INDEX} overlayInnerStyle={{margin:'0',padding:'4px'}} align={{offset:[4,0]}} arrow={false} trigger={['hover']} placement={'rightTop'}
                                                                 content={
                                                                     p.children.map(pp => {
                                                                         return (
                                                                             <div className={'flex-row-vertical-center cursor-pointer dropdown-item'} style={{padding:'12px 8px',height:'30px',margin:'0px'}} onMouseDown={(e)=>{
                                                                                 e.stopPropagation();
                                                                                 onTagAction('favor', {...tag,key:pp.key});

                                                                                 setTimeout(()=>{
                                                                                     setIsMoreMenuOpened(false);
                                                                                 },100)

                                                                             }} onMouseUp={(e)=>{
                                                                                 e.stopPropagation();
                                                                             }}>
                                                                                 <img className={'img-14'}
                                                                                      src={getImagePathWithTheme('favor_folder.svg')}/>
                                                                                 <span className={'ml-6 default-font-size'}>{pp.label}</span>
                                                                             </div>
                                                                         )
                                                                     })
                                                                 }>
                                                            <div key={p.key} style={{
                                                                height: '32px',
                                                                padding: '0 12px',
                                                                margin: '0 4px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px'
                                                            }}
                                                                 className={'flex-row-vertical-center cursor-pointer dropdown-item'}  onMouseUp={(e)=>{
                                                                e.stopPropagation();
                                                                onTagAction('favor', {...tag});

                                                                setTimeout(()=>{
                                                                    setIsMoreMenuOpened(false);
                                                                },100)
                                                            }}>
                                                                {p.icon}
                                                                {
                                                                    p.key == 'delete' ? p.label :
                                                                        <span style={{display: 'block', width: '100%'}}
                                                                              className={`${p.key == 'delete' ? 'delete-color' : ''} default-font-size`}>{p.label}</span>
                                                                }
                                                                <img className={'img-8'} style={{marginLeft:'auto'}}
                                                                     src={getImagePathWithTheme('right_arrow')}/>
                                                            </div>
                                                        </Popover> :
                                                        <div key={p.key} style={{
                                                            height: '32px',
                                                            padding: '0 12px',
                                                            margin: '0 4px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px'
                                                        }}
                                                             className={'flex-row-vertical-center cursor-pointer dropdown-item'}
                                                             onMouseUp={(event) => {
                                                                 event.stopPropagation();
                                                                 setIsMoreMenuOpened(false);
                                                                 onTagAction(p.key, tag);
                                                             }}>
                                                            {p.icon}
                                                            {
                                                                p.key == 'delete' ? p.label :
                                                                    <span style={{display: 'block', width: '100%'}}
                                                                          className={`${p.key == 'delete' ? 'delete-color' : ''} default-font-size`}>{p.label}</span>
                                                            }
                                                        </div>

                                                }
                                            </>
                                        )
                                    })
                                }
                                overlayInnerStyle={{margin: '0px', padding: '4px 0px'}}
                                overlayStyle={{minWidth: '200px', margin: '0px', padding: '0px'}}>
                                <div className={'flex-center'} style={{width: '26px', height: '26px'}}
                                     onMouseUp={(event) => {
                                         if (event.button == 0) {
                                             event.stopPropagation();
                                             event.preventDefault();
                                             setIsMoreMenuOpened(!isMoreMenuOpened);
                                         }
                                     }}>
                                    <img className={'img-14 ml-6'}
                                         src={getImagePath(getIconName())}
                                    />
                                </div>

                            </Popover>

                        }
                    </div>
                </div>
            </Tag>
        </Dropdown>

    );
});

export default memo(GroupItem);























